import React from 'react';

import ShipmentsTable from "../shipments/ShipmentsTable";

import { CANCELLED_SHIPMENTS, FEDEX } from "../shipments/constants";
import { CANCELLED } from "./constants";

// redux
import withShipment from "../../withShipment";
import {
    cancelledSelector,
    ordersSelector
} from "../../redux/selectors/orders";
import {
    fetchAllOrders
} from "../../redux/actions/orders";
import {
    saveTableSetting
} from "../../redux/actions/account";
import {
    userInfoSelector
} from "../../redux/selectors/auth";
import {
    tableSettingSelector
} from "../../redux/selectors/account";
import {
    listAvailableLocations,
    listCarriers,
} from "../../redux/actions/settings";
import {
    availableLocationsSelector,
    carriersSelector,
} from "../../redux/selectors/settings";
import PropTypes from "prop-types";

class CancelledShipments extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            searchText: '',
            defaultTableDisplay: [
                { key: 0, id: 'tag', numeric: false, disablePadding: true, label: 'Tag', selected: true },
                { key: 1, id: 'name', numeric: false, disablePadding: false, label: 'Name', selected: true },
                { key: 2, id: 'address', numeric: false, disablePadding: false, label: 'Address', selected: true },
                { key: 3, id: 'orderid', numeric: false, disablePadding: false, label: 'Order ID', selected: true },
                { key: 4, id: 'city', numeric: false, disablePadding: false, label: 'City', selected: true },
                { key: 5, id: 'state', numeric: false, disablePadding: false, label: 'State', selected: true },
                { key: 6, id: 'sku', numeric: false, disablePadding: false, label: 'SKU', selected: true },
                { key: 7, id: 'orderDate', numeric: false, disablePadding: false, label: 'Order Date', selected: true },
                { key: 8, id: 'cancelDate', numeric: false, disablePadding: false, label: 'Canceled Date', selected: true },
                { key: 9, id: 'marketplace', numeric: false, disablePadding: false, label: 'Marketplace', selected: true },
                { key: 10, id: 'shipmethod', numeric: false, disablePadding: false, label: 'Ship Method', selected: true },
                { key: 11, id: 'isprime', numeric: false, disablePadding: false, label: 'Prime', selected: true },
                { key: 12, id: 'brand', numeric: false, disablePadding: false, label: 'Brand', selected: true },
                { key: 13, id: 'postalcode', numeric: false, disablePadding: false, label: 'Postal Code', selected: true },
                { key: 14, id: 'notes', numeric: false, disablePadding: false, label: 'Notes', selected: true },
            ],
        }
    }

    componentDidMount() {
        // this.props.listLocations({ id: this.props.userInfo.company })
        this.props.listCarriers({ id: this.props.userInfo.company })
        this.props.listAvailableLocations()
        // this.props.fetchAllOrders(CANCELLED, this.getFromDate(), this.getToDate());
        this.props.saveTableSetting({
            userId: this.props.userInfo.userId,
            tableSetting: null,
            pageTitle: CANCELLED,
            defaultTable: this.state.defaultTableDisplay,
            filterSetting: null
        })
    }

    getFromDate = () => {
        var date = new Date()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 3)
        return date.toISOString()
    }

    getToDate = () => {
        var date = new Date()
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date.toISOString()
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (prevProps.cancelled !== this.props.cancelled) {
    //         this.props.fetchAllOrders()
    //     }
    // }

    handleClick = (event, shipmentid, isFedex) => {
        const selectedIndex = this.state.selected.findIndex(item => item.order === shipmentid);
        let selected = [...this.state.selected];

        if (selectedIndex === -1) {
            selected = [...selected, { order: shipmentid, isFedex }];
        } else {
            selected.splice(selectedIndex, 1);
        }
        this.setState({
            selected,
        });
    };

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = this.props.cancelled.map(n => ({
                order: n.shipmentId,
                isFedex: n.carrierService.split(" ")[0] === FEDEX
            }));
            this.setState({
                selected: newSelected,
            });
            return;
        }

        this.setState({
            selected: []
        });
    };

    isSelected = (item) => {
        const index = this.state.selected.findIndex(order => order.order === item);
        return index !== -1
    };

    clearSelected = () => {
        this.setState({ selected: [] })
    }

    handleExpand = (shipmentId, isFedex) => {
        let selected = [{ order: shipmentId, isFedex }]
        this.setState({
            selected
        });
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    render() {
        return (
            <ShipmentsTable
                title={CANCELLED_SHIPMENTS}
                shipmentStatus={CANCELLED}
                handleSelectAllClick={this.handleSelectAllClick}
                handleClick={this.handleClick}
                isSelected={this.isSelected}
                selected={this.state.selected}
                rows={this.props.cancelled}
                fetchAllOrders={this.props.fetchAllOrders}
                clearSelected={this.clearSelected}
                tableSetting={this.props.tableSetting}
                carriers={this.props.carriers}
                locations={this.props.availableLocations}
                defaultTableDisplay={this.state.defaultTableDisplay}
                handleExpand={this.handleExpand}
                history={this.props.history}
                searchText={this.state.searchText}
                handleSearchChange={this.handleSearchTextChange}
            />
        );
    }

}

const mapStateToProps = (state) => ({
    rows: ordersSelector(state),
    cancelled: cancelledSelector(state),
    userInfo: userInfoSelector(state),
    carriers: carriersSelector(state),
    tableSetting: tableSettingSelector(state),
    availableLocations: availableLocationsSelector(state)
})

const actionCreators = {
    fetchAllOrders,
    listCarriers,
    saveTableSetting,
    listAvailableLocations
}

CancelledShipments.propTypes = {
    rows: PropTypes.array,
    cancelled: PropTypes.array,
    userInfo: PropTypes.array,
    carriers: PropTypes.array,
    availableLocations: PropTypes.array,
}

CancelledShipments.defaultProps = {
    rows: [],
    cancelled: [],
    userInfo: {},
    carriers: [],
    availableLocations: [],
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, CancelledShipments);